export default __webpack_public_path__ + "static/media/blog15.5411d83d.jpg";